// components/TopBar.jsx
import React from "react";

const TopBar = ({ onSave, initialData, editMode }) => {
  return (
    <div className="topbar">
      <h1 className="calculador-title" style={{ paddingLeft: "80px" }}>
        Calculador de Costos
      </h1>
      <div className="topbar-right">
        <button className="exportar-button">
          <i className="bi bi-box-arrow-up-right me-1"></i> Exportar
        </button>
        <button className="new-task-button" onClick={onSave}>
          {initialData ? (editMode ? "Actualizar" : "Editar") : "Guardar"}
        </button>
      </div>
    </div>
  );
};

export default TopBar;
